import { useState, useEffect } from "react";

interface ManufacturerOption {
  label: string;
  value: string;
}

/**
 * Hook to get manufacturer list from manufacturerMapping.json
 * Returns sorted list of manufacturers for UI selection
 */
export const useManufacturerList = () => {
  const [manufacturers, setManufacturers] = useState<ManufacturerOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadManufacturers = async () => {
      try {
        // Import directly from shared scrapers folder
        const response = await fetch('/manufacturerMapping.json');
        const mapping = await response.json() as Record<string, string | null>;
        
        // Extract unique manufacturer names and sort them
        const manufacturerList = Object.keys(mapping)
          .filter(name => name && name.trim() !== '')
          .sort((a, b) => a.localeCompare(b, 'fr'))
          .map(name => ({
            label: name,
            value: name
          }));
        
        setManufacturers(manufacturerList);
      } catch (error) {
        console.error('[useManufacturerList] Failed to load manufacturers:', error);
        setManufacturers([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadManufacturers();
  }, []);

  return { manufacturers, isLoading };
};
